'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.service('clientInfo', function ($ionicPlatform, $rootScope) {

    var self = this;

    (0, _extend2.default)(self, {
      isIOS: undefined,
      isAndroid: undefined,
      UUID: '',
      IMEI: '',
      model: '',
      platform: '',
      EVENTS: {
        getClientInfoSuccess: 'getClientInfoSuccess'
      }
    });

    $ionicPlatform.ready(function () {
      if (window.cordova && cordova.plugins) {
        var deviceInfo = $cordovaDevice.getDevice();
        self.UUID = deviceInfo.uuid;
        self.IMEI = cordova.plugins.uid && cordova.plugins.uid.IMEI || deviceInfo.uuid;
        self.model = deviceInfo.model;
        self.platform = deviceInfo.platform;
      }
      self.isIOS = window.ionic.Platform.isIOS();
      self.isAndroid = window.ionic.Platform.isAndroid();
      $rootScope.$emit(self.EVENTS.getClientInfoSuccess, self);
    });
  });
  return app;
};

require('angular');

require('ionic');

var _extend = require('../../utils/extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 客户端信息
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/clientInfo.js
// module id = 159
// module chunks = 0